import { defineComponent } from "vue";

import AxxessHomeRouter from "./AxxessHomeRouter";

export default defineComponent({
    data(vm) {
        return {
            router: []
        };
    },
    mounted() {
        this.router = AxxessHomeRouter;
    }
});
